/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import type {ChangeEvent} from 'react';
import {useEffect, useState} from 'react';
import {Form} from 'react-bootstrap';
import {
	useGetActivePoliciesDashboardQuery,
	useLazyGetConfigServerQuery,
	useLazyGetServersQuery,
} from 'services';

export interface DataServer {
	id: string;
	url: string;
	port: string;
	available?: boolean;
}
type TCardDetail = {
	icon: string;
	data?: DataServer;
};

const CardServer = ({icon}: TCardDetail) => {
	const [getConfig] = useLazyGetConfigServerQuery();
	const [getServers] = useLazyGetServersQuery();

	const [states, setStates] = useState<any>(null);

	/* This `useEffect` hook is checking the availability of each server in the `states` array by making a
	`HEAD` request to the server's `/actuator/metrics/process.cpu.usage` endpoint. If the response
	is successful (`response.ok`), it sets the `available` property of the corresponding server object
	in the `states` array to `true`. If the request fails, it sets the `available` property to `false`.
	The `useEffect` hook runs only once when the component mounts, as it has an empty dependency array
	(`[]`). */
	useEffect(() => {
		void (async () => {
			try {
				const result = await getServers(null).unwrap();
				setStates(result);
			} catch (error) {
				setStates(null);
			}
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (states !== null) {
		const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
			const val = Number(e.target.value);
			await getConfig(val).unwrap();
			// refresh page to change server option
			location.reload();
		};

		return (
			<div className="row no-gutters align-items-center d-flex justify-content-between">
				<div className="col-md-10 mb-3">
					<label
						htmlFor="type"
						className="text-xs font-weight-bold text-info text-uppercase mb-1">
						Sites
					</label>
					<Form.Control
						defaultValue={0}
						as="select"
						// eslint-disable-next-line @typescript-eslint/no-misused-promises
						onChange={handleChange}
						className="custom-select d-block w-100">
						{states.map((el: DataServer, i: number) => (
							<option value={el.id} key={i} disabled={!el.available}>
								{el.url}:{el.port} {!el.available ? '(no disponible)' : ''}
							</option>
						))}
					</Form.Control>
				</div>
				<div className="col-auto">
					<i className={`bi-2 ${icon} text-gray-300`} />
				</div>
			</div>
		);
	}
};

const CardDetail = ({icon}: TCardDetail) => {
	const {data: getActivePoliciesDashboard} =
		useGetActivePoliciesDashboardQuery();

	const renderVersion = () =>
		getActivePoliciesDashboard?.version
			? `V${getActivePoliciesDashboard?.version}`
			: '-';

	const renderTitle = () =>
		getActivePoliciesDashboard?.title ? getActivePoliciesDashboard?.title : '-';

	const renderDescription = () =>
		getActivePoliciesDashboard?.description
			? getActivePoliciesDashboard?.description
			: '';

	return (
		<div className="row no-gutters align-items-center">
			<div className="col mr-2">
				<div className="text-xs font-weight-bold text-info text-uppercase mb-1">
					Active Policy
				</div>
				<div className="row no-gutters align-items-center">
					<div className="col-auto">
						<div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
							{renderTitle() + ' - ' + renderVersion()}
						</div>
					</div>
				</div>
				<div className="row no-gutters align-items-center">
					<div className="col-auto">
						<div className="mb-0 mr-3 mt-3  text-gray-800">
							{renderDescription()}
						</div>
					</div>
				</div>
			</div>
			<div className="col-auto">
				<i className={`bi-2 ${icon} text-gray-300`} />
			</div>
		</div>
	);
};

const Cards: React.FC<{hasPolicy?: boolean}> = ({hasPolicy}) => (
	<div className="row mt-4">
		<div className="mb-4">
			<div className="d-flex justify-content-between">
				<div className="col-xl-3 col-md-6 reduce-pl">
					<div className="card border-left-info h-100 py-2">
						<div className="card-body">
							<CardServer icon="bi-server" />
						</div>
					</div>
				</div>
				{hasPolicy && (
					<div className="col-xl-3 col-md-6 reduce-pr">
						<div className="card border-left-info h-100 py-2">
							<div className="card-body">
								<CardDetail icon="bi-clipboard-data-fill" />
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	</div>
);

export default Cards;
